import Vue from 'vue'
import VueRouter from 'vue-router'
import rszdyrmyy from '@/views/visualizationPage.vue'
import login from '@/views/login.vue'
Vue.use(VueRouter)
const routes = [
  {
    path: '/rzsdyrmyy',
    component: rszdyrmyy,

  },

  {
    path: '/',
    component: login
  },
]

const router = new VueRouter({
  routes
})
export default router
